import dayjs from 'dayjs';

export enum StatutActivite {
  deplacement = 'En Déplacement',
  intervention = 'En Intervention',
  pause = 'En pause',
}

export type HorodatageActivite = {
  dateDebut: string;
  statutActivite: StatutActivite;
  dateFin?: string;
  duree?: number;
};

export class ChronoActivite {
  idActivite: string;

  horodatageEncours: HorodatageActivite;
  horodatagesTermines: HorodatageActivite[];

  dateDebutIntervention: string = null;
  dateFinIntervention: string = null;
  dateDebutDeplacement: string = null;
  dateFinDeplacement: string = null;

  constructor(idActivite: string, statutInitial: StatutActivite = StatutActivite.intervention) {
    this.idActivite = idActivite;
    this.horodatagesTermines = [];
    this.demarrerNouveauHorodatage(statutInitial);
  }

  demarrerNouveauHorodatage(statut: StatutActivite = StatutActivite.intervention) {
    this.horodatageEncours = {
      dateDebut: dayjs().format(),
      statutActivite: statut,
    };
    this.changerDatesDebut(statut);
  }

  private changerDatesDebut(statut: StatutActivite) {
    if (statut === StatutActivite.intervention && this.dateDebutIntervention === null) {
      this.dateDebutIntervention = this.horodatageEncours.dateDebut;
    }
    if (statut === StatutActivite.deplacement && this.dateDebutDeplacement === null) {
      this.dateDebutDeplacement = this.horodatageEncours.dateDebut;
    }
  }

  stopperHorodatageEnCours() {
    let dateFin: string = dayjs().format();
    let horodatage: HorodatageActivite = {
      dateDebut: this.horodatageEncours.dateDebut,
      dateFin: dateFin,
      duree:
        (dayjs(dateFin).toDate().getTime() - dayjs(this.horodatageEncours.dateDebut).toDate().getTime()) / 1000 / 60, // duree en minutes
      statutActivite: this.horodatageEncours.statutActivite,
    };
    this.changerDatesFin(horodatage);
    this.horodatagesTermines.push(horodatage);
    this.horodatageEncours.dateDebut = dayjs().format();
  }

  private changerDatesFin(horodatage: HorodatageActivite) {
    if (horodatage.statutActivite === StatutActivite.intervention) {
      this.dateFinIntervention = horodatage.dateFin;
    }
    if (horodatage.statutActivite === StatutActivite.deplacement) {
      this.dateFinDeplacement = horodatage.dateFin;
    }
  }

  calculerDureeIntervention(): number {
    let dureeIntervention = 0;
    for (let horodatage of this.horodatagesTermines) {
      if (horodatage.statutActivite === StatutActivite.intervention) {
        dureeIntervention += horodatage.duree;
      }
    }
    if (dureeIntervention < 1) {
      dureeIntervention = 1;
    }
    return Math.round(dureeIntervention);
  }

  calculerDureeDeplacement(): number {
    let dureeDeplacement = 0;
    for (let horodatage of this.horodatagesTermines) {
      if (horodatage.statutActivite === StatutActivite.deplacement) {
        dureeDeplacement += horodatage.duree;
      }
    }
    if (dureeDeplacement < 1) {
      dureeDeplacement = 1;
    }
    return Math.round(dureeDeplacement);
  }
}
